import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Card } from "./ui/card";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import PixPayment from "./PixPayment";
import { brl } from "./PurchaseDialog";

const CLS = { awaiting_payment: "text-orange-500", held: "text-amber-500", completed: "text-emerald-500", cancelled: "text-rose-500" };

const PurchaseRow = ({ p, onChanged }) => {
  const [pix, setPix] = useState(null);
  const act = async (fn) => { try { await fn(); } catch (e) { toast.error(formatApiError(e)); } };
  const confirm = () => act(async () => {
    if (!window.confirm("Confirmar que recebeu o produto/serviço? A compra será concluída e o valor liberado à empresa.")) return;
    await api.post(`/partner-purchases/${p.id}/confirm`);
    toast.success(`Compra validada! Você recebeu ${brl(p.split.cashback)} de volta.`);
    onChanged();
  });
  const payPix = () => act(async () => { const { data } = await api.post(`/partner-purchases/${p.id}/pix`); setPix(data); });
  return (
    <Card className="p-4" data-testid={`partner-purchase-${p.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <div className="font-medium">#{p.code} · {p.company_name}</div>
          <div className="text-xs text-muted-foreground">{new Date(p.created_at).toLocaleString("pt-BR")} · {p.method_label}</div>
        </div>
        <div className="text-right">
          <div className="font-mono">{brl(p.amount)}</div>
          <Badge variant="outline" className={CLS[p.status]} data-testid={`partner-purchase-status-${p.id}`}>{p.status_label}</Badge>
        </div>
      </div>
      <div className="text-xs text-emerald-500 mt-1">Seu desconto: {brl(p.split.cashback)} ({p.discount_percent - 2}%)</div>
      {p.status === "held" && (
        <Button size="sm" className="mt-3 bg-emerald-600 hover:bg-emerald-700 text-white" onClick={confirm} data-testid={`partner-purchase-confirm-${p.id}`}>Validar compra</Button>
      )}
      {p.status === "awaiting_payment" && (pix ? <div className="mt-3"><PixPayment initial={pix} onPaid={() => { setPix(null); onChanged(); }} /></div>
        : <Button size="sm" className="gold-btn mt-3" onClick={payPix} data-testid={`partner-purchase-pay-${p.id}`}>Pagar com Pix</Button>)}
    </Card>
  );
};

export const MyPartnerPurchases = ({ items, onChanged }) => (
  items.length === 0
    ? <p className="text-sm text-muted-foreground" data-testid="partner-purchases-empty">Nenhuma compra com parceiros ainda.</p>
    : <div className="grid md:grid-cols-2 gap-4" data-testid="partner-purchases-list">{items.map((p) => <PurchaseRow key={p.id} p={p} onChanged={onChanged} />)}</div>
);
